/**
 * Created by mauget on 2/25/16.
 */

import Immutable    from 'immutable';
import _ from 'lodash';

//========================================================================================
// This object maps server object type keys to internal JS designer factory objects.
// -Lou Mauget, February 25, 2016
//========================================================================================
export const typeToFactoryKey = Immutable.Map( {

    'barchart': 'control_bar_chart',
    'bullettext': 'control_bullet_text',
    'button': 'control_button',
    'captcha': 'control_captcha',
    'tickbox': 'control_checkbox',
    'tickboxgroup': 'control_checkbox_group',
    'clearfilterbutton': 'control_clear_filter_button',
    'crosstab': 'control_crosstab',
        // 'datagrid': 'control_data_grid',
    'datagridrep' : 'control_data_grid',
    'datalist': 'control_data_list',
    'date': 'control_date_calendar',
    'dateinput': 'control_date_input',
    'dropdown': 'control_drop_down',
    'fileattachment': 'control_file_attachment',
    'filterselector': 'control_filter_selector',
    'filtersetter':'control_filter_input',
    //'filtersetter': 'control_filter_setter',
    'gauge': 'control_gauge_chart',
    'group': 'control_group',
    'horizontalseparator': 'control_horizontal_separator',
    'horizontalslider': 'control_horizontal_slider',
    'imageimport': 'control_image_input',
    'largeheading': 'control_large_heading',
    'linechart': 'control_line_chart',
    'link': 'control_link',
    'list': 'control_list',
    'masktextinput': 'control_mask_text_input',
    'mediumheading': 'control_medium_heading',
    'movie': 'control_movie',
    'textarea': 'control_multiple_text_input',
    'numericinput': 'control_numeric_input',
    'numericstepper': 'control_numeric_stepper',
        'FIX4_group': 'control_page',
    'pagebutton': 'control_page_button',
    'passwordinput': 'control_password_input',
    'picture': 'control_picture',
    'piechart': 'control_pie_chart',
    'playnewbutton': 'control_play_form_button',
    'playreportbutton': 'control_play_report_button',
    'printbutton': 'control_print_button',
    'progressbar': 'control_progress_bar',
    'radiobutton': 'control_radio_button',
    'radiobuttongroup': 'control_radio_button_group',
    'ranking': 'control_ranking',
    'smallheading': 'control_small_heading',
    'smalltext': 'control_small_text',
    'sound': 'control_sound',
    'submitbutton': 'control_submit_button',
    'table': 'control_table',
    'text': 'control_text',
    'textinput': 'control_text_input',
        //'sdfasdf': 'control_text_search',
    'timeinput': 'control_time_input',
    'timer': 'control_timer',
    'value': 'control_value',
    'verticalseparator': 'control_vertical_separator',
    'verticalslider': 'control_vertical_slider',
    'websignature': 'control_websignature'

} );

export const inverseTypeMap = Immutable.Map( _.invert( typeToFactoryKey.toJS() ) );
export default typeToFactoryKey;
